@if (icon()) {
  <i
    [class]="icon() + ' text-xs'"
    aria-hidden="true"
  ></i>
}
<span class="flex flex-col flex-1 min-w-0">
  <span
    class="font-medium text-sm"
    [class.text-red-600]="danger()"
    [class.dark:text-red-400]="danger()"
  >
    {{ title() }}
  </span>
  @if (subtitle()) {
    <span class="text-xs text-surface-400">{{ subtitle() }}</span>
  }
</span>
@if (selected()) {
  <i
    class="pi pi-check text-xs ml-auto text-primary-500"
    aria-hidden="true"
  ></i>
}
